import { useRef } from 'react';

const KEYS: [string, string][] = [
  ['1', ''], ['2', 'ABC'], ['3', 'DEF'],
  ['4', 'GHI'], ['5', 'JKL'], ['6', 'MNO'],
  ['7', 'PQRS'], ['8', 'TUV'], ['9', 'WXYZ'],
  ['*', ''], ['0', '+'], ['#', ''],
];

interface Props {
  onDigit: (d: string) => void;
  compact?: boolean;
}

/** 12-key pad. Long-press 0 types "+". */
export function Keypad({ onDigit, compact }: Props) {
  const pressTimer = useRef<number | undefined>(undefined);
  const longPressed = useRef(false);

  const down = (d: string) => {
    longPressed.current = false;
    if (d !== '0') return;
    pressTimer.current = window.setTimeout(() => {
      longPressed.current = true;
      onDigit('+');
    }, 600);
  };
  const up = (d: string) => {
    window.clearTimeout(pressTimer.current);
    if (!longPressed.current) onDigit(d);
  };

  return (
    <div className={`keypad ${compact ? 'compact' : ''}`} role="group" aria-label="Keypad">
      {KEYS.map(([d, sub]) => (
        <button
          key={d}
          type="button"
          className="key"
          data-digit={d}
          aria-label={d}
          onPointerDown={() => down(d)}
          onPointerUp={() => up(d)}
          onPointerLeave={() => window.clearTimeout(pressTimer.current)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onDigit(d);
            }
          }}
        >
          <span className="key-digit">{d}</span>
          <span className="key-sub">{sub}</span>
        </button>
      ))}
    </div>
  );
}
